import type { ComponentProps } from 'react';
import { resizeServingUrl } from '~/utils/image';
import { Image } from '@styled-system/jsx';
import placeholder from './assets/character-placeholder.png';

type Props = ComponentProps<typeof Image>;

export const CharacterIcon = ({ ...props }: Props) => (
  <Image
    w="40px"
    h="40px"
    borderRadius="full"
    alt={props.alt}
    {...props}
    src={resizeServingUrl(props.src || placeholder, 120, true)!}
  />
);
